import HttpRequest from "./http_request";

class WebPortalProvider extends HttpRequest {
  SignIn(data) {
    return this.post_guest("/api/auth/login", data);
  }
  MaintenanceStatus() {
    return this.post_guest("/api/auth/maintenance", {});
  }
  // post_auth, not post: the route is /api/auth/logout (no portal prefix) and
  // the server needs the bearer token to know which session to revoke (#50).
  SignOut(data) {
    return this.post_auth("/api/auth/logout", data);
  }
  ForgotPassword(data) {
    return this.post_guest("/api/auth/forgotpassword", data);
  }
  ResetPassword(data) {
    return this.post_guest("/api/auth/resetpassword", data);
  }

  resetPasswordNumber(data) {
    return this.post("v4/number/resetpassword", data);
  }

  GetProfile(data) {
    return this.post("profile", data);
  }

  ChangeProfile(data) {
    return this.post("profile/change", data);
  }

  ChangePassword(data) {
    return this.post("profile/password/change", data);
  }

  AuthCreate(data) {
    return this.post("v4/user/create", data);
  }

  AuthUpdate(data) {
    return this.post("v4/user/update", data);
  }
  AuthDelete(data) {
    return this.post("user/delete", data);
  }
  AuthList(data) {
    return this.post("v4/user", data);
  }

  PackageCreate(data) {
    return this.post("v4/package/create", data);
  }
  PackageUpdate(data) {
    return this.post("v4/package/update", data);
  }
  PackageDelete(data) {
    return this.post("v4/package/delete", data);
  }
  PackageList(data) {
    return this.post("v4/package", data);
  }

  MappingNumberCreate(data) {
    return this.post("v4/number/mapping/create", data);
  }
  MappingNumberUpdate(data) {
    return this.post("v4/number/mapping/update", data);
  }
  MappingNumberDelete(data) {
    return this.post("v4/number/mapping/delete", data);
  }
  MappingNumberList(data) {
    return this.post("v4/number/mapping", data);
  }

  ComProtalLogin(data) {
    return this.post("v4/number/comportal", data);
  }
  SyncPackage(data) {
    return this.postJson("v4/number/packagesync", data);
  }

  NumberImportList(data) {
    return this.post("number/import/list", data);
  }

  NumberImport(data) {
    return this.postFile("number/import/file", data);
  }

  ClearNumberImport(data) {
    return this.post("number/import/clear", data);
  }

  MlhgCreate(data) {
    return this.post("v4/mlhg/create", data);
  }
  // NOTE: no backend handler exists for either v2 or v4 rename — this
  // endpoint has been dead since v2. Kept at v4 for URL consistency with
  // the rest of the MLHG service; implement MLHGRenameV4 in the backend
  // before exposing a rename UI.
  MlhgUpdate(data) {
    return this.post("v4/mlhg/rename", data);
  }
  MlhgDelete(data) {
    return this.post("v4/mlhg/delete", data);
  }
  MlhgList(data) {
    return this.post("v4/mlhg", data);
  }

  MlhgNumberAdd(data) {
    return this.post("v4/mlhg/member/add", data);
  }
  MlhgNumberDelete(data) {
    return this.post("v4/mlhg/member/delete", data);
  }
  MlhgNumberList(data) {
    return this.post("v4/mlhg/member", data);
  }

  // voice mail
  VoicemailSync(data) {
    return this.post("voicemailsync", data);
  }

  VoicemailList(data) {
    return this.post("voicemail", data);
  }

  // CDR
  ReportCdr(data) {
    return this.post("v4/report/cdr", data);
  }

  ReportCDRV3(data) {
    return this.post("v4/report/cdr", data);
  }
  ReportDashboardV3(data) {
    return this.post("v4/report/dashboard", data);
  }
  // ---------- v4: multi-EAS-server endpoints ----------
  CorpCreateV4(data) {
    return this.post("v4/corporate/create", data);
  }
  CorpRenameV4(data) {
    return this.post("v4/corporate/rename", data);
  }
  CorpDeleteV4(data) {
    return this.post("v4/corporate/delete", data);
  }
  CorpListV4(data) {
    return this.post("v4/corporate", data);
  }

  PilotNumberCreateV4(data) {
    return this.post("v4/number/pilot/create", data);
  }
  PilotNumberDeleteV4(data) {
    return this.post("v4/number/pilot/delete", data);
  }
  PilotNumberListV4(data) {
    return this.post("v4/number/pilot", data);
  }
  PilotNumberListByEnterpriseV4(data) {
    return this.post("v4/numberbyenterprise/pilot", data);
  }

  NumberCreateV4(data) {
    return this.post("v4/number/create", data);
  }
  NumberUpdateV4(data) {
    return this.post("v4/number/update", data);
  }
  NumberDeleteV4(data) {
    return this.post("v4/number/delete", data);
  }
  NumberListV4(data) {
    return this.post("v4/number", data);
  }
  NumberListByEnterpriseV4(data) {
    return this.post("v4/numberbyenterprise", data);
  }

  CapacityListV4(data) {
    return this.post("v4/capacity", data);
  }

  EventLogListV4(data) {
    return this.post("v4/eventlog", data);
  }
  EventLogSessionV4(data) {
    return this.post("v4/eventlog/session", data);
  }
  EventLogExportV4(data) {
    return this.postBlob("v4/eventlog/export", data);
  }
  MigrationClearV4(data) {
    return this.post("v4/migration/clear", data);
  }

  // ---- EAS migration (#35) ----
  //
  // Three steps, not two (#41): preflight only reports, /read pulls and stores
  // the whole picture without touching anything and leaves the job resting at
  // status 4 (read_ok), and /start authorises the destructive half of that same
  // job. /read takes an enterprise, /start takes the migration id the read
  // produced — authorising by enterprise would authorise whichever read
  // happened to be lying around.
  EasMigrationPreflightV4(data) {
    return this.post("v4/easmigration/preflight", data);
  }
  EasMigrationReadV4(data) {
    return this.post("v4/easmigration/read", data);
  }
  EasMigrationStartV4(data) {
    return this.post("v4/easmigration/start", data);
  }
  EasMigrationStatusV4(data) {
    return this.post("v4/easmigration/status", data);
  }
  EasMigrationListV4(data) {
    return this.post("v4/easmigration", data);
  }
  EasMigrationLogListV4(data) {
    return this.post("v4/easmigration/log", data);
  }
  // The repositories the read pulled for ONE work item, payload included.
  //
  // Separate from /status on purpose: a single item carries the CFS half, the
  // EAS half and one row per service indication, each holding a whole SOAP
  // body, so folding these into the item list would put megabytes on the wire
  // every two seconds while a job is polling. It is called when a row is
  // opened and at no other time.
  EasMigrationSnapshotV4(data) {
    return this.post("v4/easmigration/snapshot", data);
  }
  // /retry answers with the same envelope as /start so the page has one code
  // path for both. It continues a failed job from where it stopped — the worker
  // re-probes MetaSwitch per item — it does not start over.
  EasMigrationRetryV4(data) {
    return this.post("v4/easmigration/retry", data);
  }
  EasMigrationExportV4(data) {
    return this.postBlob("v4/easmigration/export", data);
  }
  // ---- voicemail backup and restore ----
  //
  // An EAS migration destroys every voicemail message stored on the source EAS
  // Server, so the operator takes a copy first — and must be able to put it
  // back afterwards. The archive is KEPT on the server: nothing here deletes
  // it, and there is no /clear. Retention (newest N zips, oldest deleted when a
  // new backup starts) is the backend's business.
  //
  // /backup/start and /restore/start both open a JOB and answer with its JobId,
  // and from that point the two flows are the same three calls — /job/status
  // while it runs, /job/list and /job/log afterwards — which is why the job
  // endpoints are NOT named after either operation. A restore names the
  // COMPLETED BACKUP job whose zip it replays; the restore gets its own JobId.
  //
  // /job/download is the only GET: it streams a file in answer to a query
  // parameter, so it uses getBlob rather than post. A plain <a href> cannot be
  // used at all — it carries no Authorization header — and a plain get() would
  // let axios decode the zip as text and hand back a corrupted archive that
  // still looks like a success.
  VoicemailBackupStartV4(data) {
    return this.post("v4/voicemail/backup/start", data);
  }
  VoicemailRestoreStartV4(data) {
    return this.post("v4/voicemail/restore/start", data);
  }
  // Restore from an archive the OPERATOR uploads, rather than from one the
  // server still happens to hold.
  //
  // The API runs on two nodes behind nginx with no shared volume, so a backup's
  // zip only ever exists on the disk of whichever node produced it, and the
  // keep-newest-N sweep retires it besides. The server copy is therefore
  // scratch: the copy that matters is the one the operator downloaded from the
  // backup modal. This endpoint hands that file back, and the node that
  // receives it writes it to its own disk and runs the restore itself — which
  // is why the job row is stamped with that node before a worker can claim it.
  //
  // `formData` must carry `enterprise_id` and then `file`; the enterprise names
  // the corporate the archive was taken FROM, and the server refuses the upload
  // if the first archived document names a subscriber that is not one of that
  // corporate's numbers. The answer is the same ResVmJobStartV4 envelope
  // /restore/start returns, so the page polls it with the same /job/status
  // loop.
  //
  // timeout 0 rather than the instance-wide 120 s: this body is a whole
  // corporate's voicemail, and 120 s is a limit written for a form post.
  VoicemailRestoreUploadV4(formData, onUploadProgress) {
    return this.postFile("v4/voicemail/restore/upload", formData, {
      timeout: 0,
      onUploadProgress
    });
  }
  VoicemailJobStatusV4(data) {
    return this.post("v4/voicemail/job/status", data);
  }
  VoicemailJobListV4(data) {
    return this.post("v4/voicemail/job/list", data);
  }
  VoicemailJobLogV4(data) {
    return this.post("v4/voicemail/job/log", data);
  }
  VoicemailJobDownloadV4(data) {
    return this.getBlob("v4/voicemail/job/download", data);
  }

  // Who the API thinks this token may do (#47). Today it answers with the one
  // flag `Migration`, read from the config.yml allow-list per request, so the
  // SPA can pick up a membership change without the operator logging out.
  GetPermission(data) {
    return this.post("v4/permission", data);
  }

  CapacityExportV4(data) {
    return this.postBlob("v4/capacity/export", data);
  }
  CorpExportV4(data) {
    return this.postBlob("v4/corporate/export", data);
  }
  PilotNumberExportV4(data) {
    return this.postBlob("v4/number/pilot/export", data);
  }
  NumberExportV4(data) {
    return this.postBlob("v4/number/export", data);
  }
}

export default WebPortalProvider;
